import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./header";

const API_ENDPOINT = API_URL + "/api";

export function getUserPoints(params) {
    let obj = {
        ...getHeaderOptions(),
        Authorization: "Bearer " + localStorage.getItem("token"),
    };
    return axios.get(`${API_ENDPOINT}/userpoints/GetUserPoints/${params.userName}`, { headers: obj })
}

export function deductPoints(data) {
    let obj = {
        ...getHeaderOptions(),
        Authorization: "Bearer " + localStorage.getItem("token"),
    };
    return axios.post(`${API_ENDPOINT}/userpoints/DeductPoints`, data, { headers: obj })
}